import React, { Fragment } from "react";
import { Col, Container, Row } from "react-bootstrap";

function UiCol(props) {
    return (
        <Fragment>
            <Col className={props.className} xxl={props.xxl} xl={props.xl}
                lg={props.lg} md={props.md} sm={props.sm} xs={props.xs}>
                {props.children}
            </Col>
        </Fragment>
    );
}


function UiRowContainer(props) {
    return (
        <Fragment>
            <Container className={props.className} fluid={props.fluid}>
                <Row className={props.rowClassName}>
                    {props.children}
                </Row>
            </Container>

        </Fragment>
    );
}

function UiSingleContainer(props) {
    return (
        <Fragment>
            <Container className={props.className} fluid={props.fluid}>
                {props.children}
            </Container>
        </Fragment>
    );
}

function UiSingleRow(props) {
    return (
        <Fragment>
            <Row className={props.className}>
                {props.children}
            </Row>
        </Fragment>
    );
}



export { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow };
